<script lang="ts" setup>
import { useStoryDevTools } from '~/composables/unified/useStoryDevTools';

const { endingNodes, storyTitle, skipToEnding } = useStoryDevTools();

const selectedEndingId = ref(endingNodes.value[0]?.id ?? '');

watch(endingNodes, (nodes) => {
  if (nodes.length) {
    selectedEndingId.value = nodes[0]?.id ?? '';
  }
}, { immediate: true });

const handleComplete = () => {
  if (selectedEndingId.value) {
    skipToEnding(selectedEndingId.value);
  }
};
</script>

<template>
  <div class="px-3 py-1">
    <span
      v-if="storyTitle"
      class="mb-1.5 block truncate text-xs text-foreground"
    >
      {{ storyTitle }}
    </span>
    <div class="flex items-center gap-1.5">
      <select
        v-model="selectedEndingId"
        class="flex-1 rounded-md border bg-white px-2 py-1 text-xs text-muted-foreground"
      >
        <option
          v-for="node in endingNodes"
          :key="node.id"
          :value="node.id"
        >
          {{ node.internalName }}
        </option>
      </select>
      <button
        class="shrink-0 rounded-md px-2 py-0.5 text-xs font-medium text-primary-foreground bg-primary hover:brightness-90"
        @click="handleComplete"
      >
        Complete
      </button>
    </div>
  </div>
</template>
